// SiteUp: inset lateral único da coluna de conversas. O gutter da barra
// (scrollbar-gutter: stable both-edges) fica FORA desse inset, para header,
// busca, abas e cards coincidirem com e sem barra visível, sem o pulo.
export const CONVERSATION_COLUMN_INSET_CLASS = 'px-4';
export const CONVERSATION_COLUMN_COMPACT_INSET_CLASS = 'px-2';

export const CONVERSATION_COLUMN_SCROLL_GUTTER_CLASS =
  'overflow-y-auto [scrollbar-gutter:stable_both-edges]';

// Trilho de um lado só: reserva a mesma largura de gutter da lista, sem
// overflow no cromo (menus/overlay da busca continuam visíveis).
export const CONVERSATION_COLUMN_SCROLL_GUTTER_EDGE_CLASS =
  'invisible pointer-events-none shrink-0 self-stretch overflow-y-auto [scrollbar-gutter:stable]';

// Cartão flutuante das colunas da área de trabalho (lista, conversa, contato).
// Mesmos tokens da lista: raio 12 (rounded-xl), borda 1px em border-n-weak,
// fundo n-surface-1. overflow-hidden faz header e compositor respeitarem o raio.
// Respiro vertical: 8px (my-2). O vão horizontal ENTRE cartões é o handle de
// 8px (w-2), não margem extra: lista só na esquerda, contato só na direita.
export const WORKBENCH_PANEL_CARD_CLASS =
  'rounded-xl border border-n-weak overflow-hidden bg-n-surface-1';
export const WORKBENCH_PANEL_CARD_Y_CLASS = 'my-2';
export const WORKBENCH_PANEL_CARD_START_CLASS = 'ml-2';
export const WORKBENCH_PANEL_CARD_END_CLASS = 'mr-2';

export const WORKBENCH_LIST_PANEL_CARD_CLASS = [
  WORKBENCH_PANEL_CARD_CLASS,
  WORKBENCH_PANEL_CARD_Y_CLASS,
  WORKBENCH_PANEL_CARD_START_CLASS,
].join(' ');

export const WORKBENCH_CONVERSATION_PANEL_CARD_CLASS = [
  WORKBENCH_PANEL_CARD_CLASS,
  WORKBENCH_PANEL_CARD_Y_CLASS,
].join(' ');

export const WORKBENCH_CONTACT_PANEL_CARD_CLASS = [
  WORKBENCH_PANEL_CARD_CLASS,
  WORKBENCH_PANEL_CARD_Y_CLASS,
  WORKBENCH_PANEL_CARD_END_CLASS,
].join(' ');
